import { render, staticRenderFns } from "./SampleDetailCardstack.vue?vue&type=template&id=25e75a3c"
import script from "./SampleDetailCardstack.vue?vue&type=script&lang=js"
export * from "./SampleDetailCardstack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports